/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AwsSecurityHubFindingResourcesResponse {
    getFixupPrototypeFunction() { return AwsSecurityHubFindingResourcesResponse.fixupPrototype; }

    static newInstance(model: Partial<AwsSecurityHubFindingResourcesResponse>): AwsSecurityHubFindingResourcesResponse {
        let obj = Object.assign(new AwsSecurityHubFindingResourcesResponse(), model);
        AwsSecurityHubFindingResourcesResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AwsSecurityHubFindingResourcesResponse>): AwsSecurityHubFindingResourcesResponse {
        if (!model) return null;
        return AwsSecurityHubFindingResourcesResponse.newInstance(<AwsSecurityHubFindingResourcesResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AwsSecurityHubFindingResourcesResponse) {
        if (!obj) return;

        models.AwsSecurityHubFindingResourcesResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AwsSecurityHubFindingResourcesResponse): boolean {
        Object.setPrototypeOf(obj, AwsSecurityHubFindingResourcesResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * List of Resources
     */
    resources: Array<string>;

}
